import { API, APICall } from '../Api'

export default {
  name: 'Promotions',

  methods: {
    async get (id) {
      const Request = {
        Type    : APICall.Promotion.Get.Type,
        Endpoint: APICall.Promotion.Get.Endpoint.replace('{id}', id),
        Data    : {}
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async save (data) {
      if (typeof this.clearServerErrorMessages === 'function') this.clearServerErrorMessages()
      const Request = {
        Type    : APICall.Promotion.Save.Type,
        Endpoint: APICall.Promotion.Save.Endpoint,
        Data    : data
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async all (data) {
      const Request = {
        Type    : APICall.Promotion.List.Type,
        Endpoint: APICall.Promotion.List.Endpoint,
        Data    : data || this.requestData()
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    }

  }

}
